import { isNull } from 'lodash-es'
import { useTranslations } from 'next-intl'

import {
  AccountUpdate,
  useAccountValidation,
  useGuestDepositReturnAccount,
} from '@/features/update-account'
import { useFormatDate } from '@/shared/lib'

type Props = {
  contractId: number
}

export const DepositReturnAccount = ({ contractId }: Props) => {
  const t = useTranslations('deposit_information')
  const { formatDateWithDayOfWeek } = useFormatDate()

  const { depositReturnAccount, hasDepositReturnAccount } =
    useGuestDepositReturnAccount({ contractId })

  const { handleAccountFormOpen } = useAccountValidation()

  const isEditable = depositReturnAccount?.isEditAvailable ?? true

  const isDepositReturned =
    depositReturnAccount?.isDepositReturned &&
    !isNull(depositReturnAccount?.depositReturnedAt)

  return (
    <div className="space-y-3">
      <h3 className="typo-body1 font-semibold text-black">
        {t('refund_account.title')}
      </h3>

      <div className="space-y-2">
        {(() => {
          if (isEditable) {
            return (
              <AccountUpdate
                defaultFormOpen={!hasDepositReturnAccount(depositReturnAccount)}
                hasDefaultAccount={hasDepositReturnAccount(
                  depositReturnAccount,
                )}
                description={t('refund_account.description')}
                onFormOpen={handleAccountFormOpen}
              />
            )
          }

          const displayAccount = hasDepositReturnAccount(depositReturnAccount)
            ? `${depositReturnAccount.depositReturnBankName} ${depositReturnAccount.depositReturnBankAccount} (${depositReturnAccount.depositReturnBankHolder})`
            : t('account_info.empty')

          return (
            <>
              <p className="typo-label1 font-medium text-gray-900">
                {displayAccount}
              </p>
              {isDepositReturned && (
                <p className="typo-body1 font-bold text-purple-500">
                  {t('date_status.complete', {
                    date: formatDateWithDayOfWeek({
                      date: depositReturnAccount.depositReturnedAt!,
                    }),
                  })}
                </p>
              )}
            </>
          )
        })()}
      </div>
    </div>
  )
}
